import {
  PublishParams,
  ContractFields,
  ContractListParams,
} from "../../view/Modules/CompanyContracts/ContractDataTypes";
import AxiosInstance from "../config/axiosInterceptor";
import { ContentApiRoutes } from "../../navigation/NavConstant";

export const ContractServices = {
  getContracts: (params: ContractListParams) => {
    if (params.keyword !== "") {
      return AxiosInstance.get(ContentApiRoutes.CONTRACTS, {
        params,
      });
    }
    return AxiosInstance.get(ContentApiRoutes.CONTRACTS, { params });
  },
  createContract: (data: ContractFields) =>
    AxiosInstance.post(ContentApiRoutes.CREATE_CONTRACT, data),
  updateContract: (id: number, data: ContractFields) =>
    AxiosInstance.post(
      ContentApiRoutes.UPDATE_CONTRACT.replace(":id", id.toString()) +
        "?_method=PUT",
      data
    ),
  publishContract: (id: number, data: PublishParams) =>
    AxiosInstance.put(
      ContentApiRoutes.PUBLISH_CONTRACT.replace(":id", id.toString()),
      data
    ),
  deleteContract: (id: number) =>
    AxiosInstance.delete(
      ContentApiRoutes.DELETE_CONTRACT.replace(":id", id.toString())
    ),

  viewContract: (id: number) => {
    return AxiosInstance.get(
      ContentApiRoutes.VIEW_CONTRACT.replace(":id", id.toString())
    );
  },
};
